import { BrowserRouter as Router, Routes, Route, Outlet, useLocation, Link } from 'react-router-dom';
import { useEffect } from 'react';
import App from './App';
import PrivacyPage from './pages/PrivacyPage';
import AboutPage from './pages/AboutPage';
import TermsPage from './pages/TermsPage';
import Footer from './components/Footer';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const MainLayout = () => (
  <div className="min-h-screen flex flex-col">
    <header className="bg-white dark:bg-gray-800 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="text-xl font-bold text-gray-900 dark:text-white hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
            ← Back to Game
          </Link>
        </div>
      </div>
    </header>
    
    <main className="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-4xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 sm:p-8">
          <Outlet />
        </div>
      </div>
    </main>
    
    <Footer />
  </div>
);

const AppRouter = () => (
  <Router>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<App />} />
      <Route element={<MainLayout />}>
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Route>
    </Routes>
  </Router>
);

export default AppRouter;
